import { formatDateDashes } from "@transfr-inc/dashboard-components/utils";

export const sortObjectArrayByKey = (arr, key) => {
  return arr.sort((a, b) => {
    if (a[key] < b[key]) {
      return -1;
    }
    if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  });
};

export const capitalizeWord = (word) => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

export const stringToBoolean = (value) => {
  const booleanValues = ["true", "1"];
  return booleanValues.includes(value?.toLowerCase());
};

export const parseStringBoolean = (value) =>
  String(value).trim().toLowerCase() === "true";

export const isNullishFromString = (value) => {
  const nullishValues = ["null", "undefined"];
  return nullishValues.includes(value?.toLowerCase());
};

export const formatDateSlashes = (date) => {
  const dateComponents = formatDateDashes(date).split("-");
  return `${dateComponents[1]}/${dateComponents[2]}/${dateComponents[0]}`;
};
